import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"theaters"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.5 3L7.5 21H3L3 3L7.5 3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.75 3L20.75 21H16.25L16.25 3L20.75 3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 21L3 3M3 21H21M3 21H7.5L7.5 3L3 3M3 3L21 3M21 3V21M21 3L16.5 3V21H21M3 7.5L8 7.5M3 12H8M3 16.5H8M16 7.5L21 7.5M16 12H21M16 16.5H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Theaters = Vue.extend<IconProps>({
  name: 'TheatersIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'theaters',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Theaters;
